import { Link } from "react-router-dom";
import { vehicleMarketAnalyticsClassPath } from "../../../constants/transport";
import { formatCop, formatMileage } from "./vehicleMarketFormat";

const VehicleClassAnalyticsCard = ({ classSummary }) => {
  const goodDeals = (classSummary.greatDealCount || 0) + (classSummary.goodDealCount || 0);

  return (
    <article className="vehicle-analytics-card panel-card">
      <h3>
        <Link to={vehicleMarketAnalyticsClassPath(classSummary.vehicleClass)}>
          {classSummary.vehicleClassName || classSummary.vehicleClass}
        </Link>
      </h3>
      <p className="vehicle-analytics-card__stat">
        <strong>{classSummary.activeVehicleCount}</strong> active vehicles
        {classSummary.activeListingCount > classSummary.activeVehicleCount ? (
          <span className="muted">
            {" "}
            ({classSummary.activeListingCount} listings)
          </span>
        ) : null}
      </p>
      <p>Median price: {formatCop(classSummary.medianPriceCop)}</p>
      <p className="muted">
        Range: {formatCop(classSummary.minPriceCop)} – {formatCop(classSummary.maxPriceCop)}
      </p>
      {classSummary.medianMileageKm != null ? (
        <p>Median mileage: {formatMileage(classSummary.medianMileageKm)}</p>
      ) : null}
      <p>
        {goodDeals} good/great deal{goodDeals === 1 ? "" : "s"} ·{" "}
        {classSummary.priceDropCount30d ?? 0} price drops (30d)
      </p>
      <Link
        to={vehicleMarketAnalyticsClassPath(classSummary.vehicleClass)}
        className="crm-btn crm-btn-secondary"
      >
        View class details
      </Link>
    </article>
  );
};

export default VehicleClassAnalyticsCard;
